import { render, staticRenderFns } from "./DispatchBoard.vue?vue&type=template&id=7e874c4e&scoped=true&"
import script from "./DispatchBoard.vue?vue&type=script&lang=js&"
export * from "./DispatchBoard.vue?vue&type=script&lang=js&"
import style0 from "./DispatchBoard.vue?vue&type=style&index=0&id=7e874c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e874c4e",
  null
  
)

export default component.exports